import { color } from '@upstox/upstox-ui';

export const container: CSSFunction = () => ({
  padding: '16px',
  flexDirection: 'column',
  gap: '16px',
});

export const heading: CSSFunction = ({ theme }) => ({
  color: color(theme, 'text.1'),
  fontSize: '20px',
  fontWeight: '700',
});
